import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irembogov-publish-confirmation-modal',
  templateUrl: './publish-confirmation-modal.component.html',
  styleUrls: ['./publish-confirmation-modal.component.scss'],
})
export class PublishConfirmationModalComponent {
  @Input() templateName!: string;
  @Input() show = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }

  onBackdropClick(event: Event): void {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
